





























































import { Component } from 'vue-property-decorator';

import DclAdd from '@/components/DraggableCardList/DclAdd.vue';
import DclCard from '@/components/DraggableCardList/DclCard.vue';
import DclGrid from '@/components/DraggableCardList/DclGrid.vue';
import HoursSection from './HoursSection';
import { Hours } from '@/services/Location';

@Component({
	components: {
		DclAdd,
		DclCard,
		DclGrid,
	}
})
export default class HoursLobby extends HoursSection {
	hoursType = 'lobbyHours';

	get hoursList(): Array<Hours> {
		return this.location[this.hoursType] as Array<Hours>;
	}

	set hoursList(list: Array<Hours>) {
		if (!list.length) {
			list.push({...this.blank} as Hours);
		}
		this.$set(this.location, this.hoursType, list);
		if (this.location.driveThroughSameAsLobby) {
			this.$set(this.location, 'lobbyHours', this.dereference(list));
		}
	}

	syncItem(index: number, key: string, value: string) {
		if (this.location.driveThroughSameAsLobby) {
			((this.location.driveThroughHours as Array<Hours>)[index] as Hours)[key] = value;
		}
	}

	syncList() {
		if (this.location.driveThroughSameAsLobby) {
			this.$set(this.location, 'driveThroughHours', this.dereference(this.hoursList));
		}
	}

	add() {
		super.add();
		this.syncList();
	}

	move(fromIndex: number, toIndex: number) {
		super.move(fromIndex, toIndex);
		this.syncList();
	}

	remove(index: number) {
		super.remove(index);
		this.syncList();
	}

}

